import {
  Box,
  TextField,
  FormHelperText,
  Typography,
  makeStyles,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useFormikContext } from 'formik';

const useStyles = makeStyles(() => ({
  characterCounter: {
    position: 'absolute',
    bottom: 10,
    right: 15,
  },
  arrowIconBox: {
    marginInline: 16,
  },
  helperText: {
    marginLeft: 0,
    paddingTop: 8,
  },
}));

export default function ActionFormFields() {
  const classes = useStyles();
  const { values, handleChange, touched, errors } = useFormikContext<{
    rotuloDoBotao: string;
    urlCta: string;
  }>();

  const textLength = values.rotuloDoBotao?.length || 0;
  const maxTextLength = 20;

  const hasRotuloError = touched.rotuloDoBotao && Boolean(errors.rotuloDoBotao);
  const hasUrlError = touched.urlCta && Boolean(errors.urlCta);
  const hasAnyError = hasRotuloError || hasUrlError;

  const helperMessage = hasAnyError
    ? (errors.rotuloDoBotao && touched.rotuloDoBotao && errors.rotuloDoBotao) ||
      (errors.urlCta && touched.urlCta && errors.urlCta)
    : 'Insira o texto do botão e o link de redirecionamento.';

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Box position="relative" width="100%">
          <TextField
            name="rotuloDoBotao"
            label="Botão"
            variant="outlined"
            value={values.rotuloDoBotao}
            onChange={handleChange}
            inputProps={{
              maxLength: maxTextLength,
              style: { marginRight: 50 },
            }}
            error={hasRotuloError}
            fullWidth
          />
          <Typography
            variant="caption"
            color="textSecondary"
            className={classes.characterCounter}
          >
            {textLength}/{maxTextLength}
          </Typography>
        </Box>

        <Box className={classes.arrowIconBox}>
          <ArrowForwardIcon color="disabled" />
        </Box>

        <TextField
          name="urlCta"
          label="URL"
          variant="outlined"
          value={values.urlCta}
          onChange={handleChange}
          error={hasUrlError}
          fullWidth
        />
      </Box>

      <FormHelperText className={classes.helperText} error={hasAnyError}>
        {helperMessage}
      </FormHelperText>
    </Box>
  );
}
